import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'friendlyName'
})
export class HeaderFriendlyNamePipe implements PipeTransform {

  headerMapper = {
    'Name': 'Nom',
    'IsActive': 'Actif',
    'OperationalGroupId': 'Groupe opérationnel',
    'RecipientEntityId': 'Société destinataire',
    'NonERPComptabilityGroupId': 'Groupe en charge de la comptabilisation',
    'Title': 'Titre',
    'Content': 'Contenu',
    'Label': 'Label',
    'SupervisorUserId': 'Référent',
    'VoucherDepartment': 'Département',
    'VoucherAnalyticalSection': 'Section analytique',
    'VoucherAnalyticalCode': 'Code analytique',
    'VoucherComment': 'Commentaire',
    'ControlGroupId': ' Groupe de contrôle',
    'IsVoucher': 'BAP',
    'ProfessionType': 'Profession'
  };

  transform(value: any): string {
    const headerLabel = this.headerMapper[value];
    if (!_.isNil(headerLabel)) {
      return headerLabel;
    }

    return value;
  }
}